import { ListItemText } from '@mui/material';
import dayjs from 'dayjs';

import AnchorWrapper from '@/components/AnchorWrapper';
import type { Asset } from '@/pages/Assets/Assets.types';
import type { VmpColumnType } from '@/pages/VulnerabilityManagement/VulnerabilityManagement.types';
import getDateTime from '@/utils/getDateTime.utils';

import {
  assetsCellFormatter,
  // TODO: add these in when we have more consistent data from shield
  // importanceFormatter,
  scoreFormatter
} from './VulnerabilityDetailsAssetTable.utils';

export const AFFECTED_ASSETS_COLUMNS: VmpColumnType<Asset>[] = [
  {
    id: 'asset_name',
    label: 'Asset Name',
    cell: (row: Asset) => assetsCellFormatter(row.id, row.asset_name),
    width: '20%'
  },
  {
    id: 'ip_address',
    label: 'IP Address',
    cell: (row: Asset) => assetsCellFormatter(row.id, row.ip_address),
    width: '20%'
  },
  {
    id: 'operating_system',
    label: 'Operating System',
    cell: (row: Asset) => assetsCellFormatter(row.id, row.operating_system),
    width: '20%'
  },
  {
    id: 'max_shield_exposure_index',
    label: 'Risk Score',
    cell: (row: Asset) => scoreFormatter(row)
  }
];

export const REMEDIATED_ASSETS_COLUMNS: VmpColumnType<Asset>[] = [
  ...AFFECTED_ASSETS_COLUMNS,
  {
    id: 'date_remediated',
    label: 'Remediated At',
    cell: (row: Asset) => {
      if (!row.date_remediated)
        return (
          <AnchorWrapper path="/asset" itemId={row.id}>
            {' '}
          </AnchorWrapper>
        );

      return (
        <AnchorWrapper path="/asset" itemId={row.id}>
          <ListItemText
            primary={`${dayjs.utc(row.date_remediated).local().fromNow(true)} ago`}
            secondary={getDateTime(row.date_remediated)}
            sx={{ margin: 0 }}
          />
        </AnchorWrapper>
      );
    }
  }
];
